<template>
  <el-dialog
    class="dialog-edit-passwd"
    :append-to-body="true"
    :visible.sync="dialogVisible"
    :title="pageType === 'reset' ? '重置密码' : '停用账号'"
    width="500px"
  >
    <!-- 重置密码 -->
    <el-form
      class="g-form-grid"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
      v-if="pageType === 'reset'"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="输入新密码" prop="pass">
            <el-input type="password" v-model="form.pass" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="重复密码" prop="checkPass">
            <el-input type="password" v-model="form.checkPass" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 停用账号 -->
    <div class="stop-account" v-if="pageType === 'stop'">
      <p class="m-assist mb-10">账号停用后：</p>
      <div class="tips">
        <p>
          <span class="m-circle-dot mr-10"></span>
          该员工账号无法登录系统
        </p>
        <p>
          <span class="m-circle-dot mr-10"></span>
          系统会保留该员工的所有数据，停用状态对其他员工不可见
        </p>
        <p>
          <span class="m-circle-dot mr-10"></span>
          停用期间，其他员工依然可以向该员工发起协作
        </p>
        <p>
          <span class="m-circle-dot mr-10"></span>
          只要没有将该员工账号删除，被停用的员工是可以恢复使用的
        </p>
      </div>
    </div>

    <div slot="footer" class="footer tc mt-30">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate } from '@/utils/util'
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (!validate(value, 'password')) {
        callback(new Error('6-20位数字、字母、特殊字符至少包含两种'))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      loadingSave: false,
      form: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [
          { required: true, message: '设置6至20位登录密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请再次输入登录密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      detailData: {},
      pageType: 'reset' // reset 重置密码  stop 停用账号
    }
  },
  methods: {
    init(item, pageType) {
      this.detailData = item
      this.pageType = pageType
      // console.log(detailId)
      this.dialogVisible = true
    },
    fromSubmit(form) {
      if (this.pageType === 'stop') {
        this.stopUser()
        return
      }
      // 重置密码
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true

          this.$http
            .post('/user/resetPassword', {
              userId: this.detailData.userId,
              pwd: this.form.pass,
              repwd: this.form.checkPass
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('重置密码成功')
                this.dialogVisible = false
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    // 停用账号
    stopUser() {
      this.loadingSave = true
      this.$http
        .post('/user/updateEmployee', {
          userId: this.detailData.userId,
          userStatus: '2'
          // userStatus: this.detailData.userStatus === '1' ? '2' : '1' // 1：启用，2：停用
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success('停用账号成功')
            // this.$message.success(
            //   this.detailData.userStatus === '1'
            //     ? '停用账号成功'
            //     : '启用账号成功'
            // )
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-edit-passwd {
  .stop-account {
    padding: 20px;
    background: $color2;
    .tips {
      line-height: 30px;
    }
  }
}
</style>


